var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendawhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5987_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45828 0C4.07161 0 4.56939 0.613333 4.56939 1.11111V3.33333C4.56939 3.94667 4.07161 4.44444 3.45828 4.44444C2.84495 4.44444 2.34717 3.83111 2.34717 3.33333V1.11111C2.34717 0.497778 2.84495 0 3.45828 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0C10.7384 0 11.2361 0.613333 11.2361 1.11111V3.33333C11.2361 3.94667 10.7384 4.44444 10.125 4.44444C9.51169 4.44444 9.01392 3.83111 9.01392 3.33333V1.11111C9.01392 0.497778 9.51169 0 10.125 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7918 0C17.4051 0 17.9029 0.613333 17.9029 1.11111V3.33333C17.9029 3.94667 17.4051 4.44444 16.7918 4.44444C16.1784 4.44444 15.6807 3.83111 15.6807 3.33333V1.11111C15.6807 0.497778 16.1784 0 16.7918 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.125 18.2222C0.125 18.6933 0.311667 19.1467 0.645 19.48C0.978333 19.8133 1.43167 20 1.90278 20H18.3472C18.8183 20 19.2717 19.8133 19.605 19.48C19.9383 19.1467 20.125 18.6933 20.125 18.2222V7.11112H0.125V18.2222ZM18.5694 2.23556V3.33334C18.5694 4.31556 17.7739 5.11112 16.7917 5.11112C15.8094 5.11112 15.0139 4.31556 15.0139 3.33334V2.22223H11.9028V3.33334C11.9028 4.31556 11.1072 5.11112 10.125 5.11112C9.14278 5.11112 8.34722 4.31556 8.34722 3.33334V2.22223H5.23611V3.33334C5.23611 4.31556 4.44056 5.11112 3.45833 5.11112C2.47611 5.11112 1.68056 4.31556 1.68056 3.33334V2.23556C0.791667 2.34667 0.125 3.10445 0.125 4.00001V6.22223H20.125V4.00001C20.125 3.10445 19.4583 2.34667 18.5694 2.23556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5987_2750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendawhite);
export default __webpack_public_path__ + "static/media/calendawhite.2b27739009e4451d6a6cb83ef0a9ccdf.svg";
export { ForwardRef as ReactComponent };